import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  ViewEncapsulation,
} from "@angular/core";
import { fromEvent } from "rxjs";
import { map, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CommonService } from "../../../core/services/v2/common.service";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { WindowLoaderService } from "../../../shared/components/window-loader/window-loader.service";
import { FormFolder } from "../../../core/models/physician/form-folder";
import { FormEditFolderComponent } from "../form-edit-folder/form-edit-folder.component";
import { FormService } from "../../../core/services/v2/form.service";
import { FormPreviewComponent } from "../form-preview/form-preview.component";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { AddPdfformComponent } from "../add-pdfform/add-pdfform.component";
import * as _ from 'lodash';

@Component({
  selector: "app-list-search-forms",
  templateUrl: "./list-search-forms.component.html",
  styleUrls: ["./list-search-forms.component.scss"],
  encapsulation: ViewEncapsulation.None

})
export class ListSearchFormsComponent implements OnInit, AfterViewInit {
  selectedOption :FormFolder;
  compareFunction = (o1: any, o2: any)=> o1.id===o2.id;
  activeFormFolders: FormFolder[];
  templateFormFolders: FormFolder[];
  toggleSidebar = false;
  sectionName: string;
  sideBarHeader: string;
  oldText: string;

  @ViewChild("formsSearchInput", { static: true }) formsSearchInput: ElementRef;
  @ViewChild(FormEditFolderComponent, { static: false })
  childComponent: FormEditFolderComponent;

  constructor(
    private practiceService: PracticeService,
    private formService: FormService,
    private loaderService: WindowLoaderService,
    private _router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    fromEvent(this.formsSearchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        if (
          (this.oldText && this.oldText.length > 0) ||
          (text && text.length > 0)
        ) {
          this.searchForms(text);
          this.oldText = text;
        }
      });
  }

  ngAfterViewInit() {
    this.searchForms("");
  }
  OnActiveFormsSelChange(ob){
    this.selectedOption=ob;
    console.log(ob)
//this.selectedOptions=ob;
  }
  searchForms(searchTerm: string) {
    this.loaderService.show();
    this.formService.getFormsDocs(searchTerm).subscribe(
      (result) => {
        console.log(result.result)
        let templist=_.filter(result.result, f => f.id !=-1);
        this.formService.activeFormFolders = _.orderBy(templist, [folder => folder.name.toLowerCase()], ['asc']);
        this.selectedOption=this.formService.activeFormFolders[0];
        if (result.resultStatus.isSuccess) {
          this.formService.getFormsTemplates(searchTerm).subscribe(
            (templ) => {
              if (templ.resultStatus.isSuccess) {
                this.templateFormFolders = templ.result;
              } else {
                console.error(templ.resultStatus);
              }
            },
            (error) => {
              console.error(error);
            },
            () => {
              this.loaderService.hide();
            }
          );
        } else {
          console.error(result.resultStatus);
        }
      },
      (error) => {
        console.error(error);
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }
  OnReloadListOfFolder(v:any){
    this.searchForms("");
 }
  toggleEditSidebar(sectionName: string) {
    this.sectionName = sectionName;
    this.practiceService.toggleSidebar = !this.practiceService.toggleSidebar;
    this.showHideScroll(this.practiceService.toggleSidebar);
  }
  togglePopUp(formFolders: FormFolder[]) {
    let templist=_.filter(formFolders, f => f.id !=-1);
        this.formService.activeFormFolders = _.orderBy(templist, [folder => folder.name.toLowerCase()], ['asc']);
    //this.formService.activeFormFolders = formFolders ? formFolders : [];
    this.practiceService.toggleSidebar = !this.practiceService.toggleSidebar;
    this.showHideScroll(this.practiceService.toggleSidebar);
  }

  add() {
    this._router.navigate([`${this.formService.spaFormDetailsRoute}0`]);
  }
  openaddPdfFormDialog() {
    const dialogRef = this.dialog.open(AddPdfformComponent, {
      width: '450px',
      //data: {name: this.name, animal: this.animal}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.searchForms("");
    });
  }
    
    
}
